<template>
<div class="form-part">
  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbc_objname_sel" class="mt-1">Obj. Name</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbc_objname" class="fit-width"></b-form-input>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox v-model="fields.lbc_propid_sel" class="mt-1">Proposal ID</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbc_propid" class="fit-width"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbc_imagetyp_sel" class="mt-1">Image Type</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.lbc_imagetyp" class="fit-width">
        <option :value="null">Select...</option>
        <option>OBJECT</option>
        <option>ZERO</option>
        <option>FLAT</option>
        <option>FOCUS</option>
      </b-form-select>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox v-model="fields.lbc_obname_sel" class="mt-1">OBs. Name</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbc_obname" class="fit-width"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbc_flt_id_sel" class="mt-1">Filter</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-select v-model="fields.lbc_flt_id" class="fit-width">
        <option :value="null">Select...</option>
        <option>U-BESSEL</option>
        <option>B-BESSEL</option>
        <option>V-BESSEL</option>
        <option>g-SLOAN</option>
        <option>r-SLOAN</option>
        <option>SDT_Uspec</option>
        <option>V-BESSEL</option>
        <option>R-BESSEL</option>
        <option>I-BESSEL</option>
        <option>r-SLOAN</option>
        <option>i-SLOAN</option>
        <option>z-SLOAN</option>
        <option>F972N20</option>
        <option>Y-FAN</option>
        <option>TiO_784</option>
        <option>CN_817</option>
        <option value="Y-FAN">Y</option>
      </b-form-select>
    </div>
    <div class="col-2 offset-1 label-left">
      <b-form-checkbox v-model="fields.lbc_obid_sel" class="mt-1">OB. ID</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbc_obid" class="fit-width"></b-form-input>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-2"></div>
    <div class="col-3 text-center"><strong>Min</strong></div>
    <div class="col-3 text-center"><strong>Max</strong></div>
  </div>
  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbc_fwhm_sel" class="mt-1">FWHM</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbc_fwhm_min" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbc_fwhm_min">{{fieldErrors.lbc_fwhm_min}}</span>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbc_fwhm_max" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbc_fwhm_max">{{fieldErrors.lbc_fwhm_max}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.lbc_ellip_sel" class="mt-1">Ellipticity</b-form-checkbox>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbc_ellip_min" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbc_ellip_min">{{fieldErrors.lbc_ellip_min}}</span>
    </div>
    <div class="col-3">
      <b-form-input v-model="fields.lbc_ellip_max" class="fit-width"></b-form-input>
      <span class="text-danger" v-if="fieldErrors.lbc_ellip_max">{{fieldErrors.lbc_ellip_max}}</span>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapState
} from 'vuex';

export default {
  name: 'Lbc',
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors
  })
}
</script>
